import type { ReactNode } from "react"

import { cn } from "@productlane/lib/src/cn"

// gray-850 is gray-800/50 over the sidebar's gray-900, so the strip matches a
// hovered row exactly and the truncated title fades under it.
const rowBg = (isSelected: boolean) =>
	isSelected ? "bg-gray-100 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-850"

const rowFade = (isSelected: boolean) =>
	isSelected ? "to-gray-100 dark:to-gray-800" : "to-gray-100 dark:to-gray-850"

export const NavRowActions = ({
	isSelected = false,
	className,
	children,
}: {
	isSelected?: boolean
	className?: string
	children: ReactNode
}) => (
	<div
		role="presentation"
		data-testid="nav-row-actions"
		className={cn(
			"absolute inset-y-0 flex items-center gap-1 rounded-md px-1 opacity-0 focus-within:opacity-100 group-hover/item:opacity-100",
			rowBg(isSelected),
			className,
		)}
		onClick={(e) => e.stopPropagation()}
		onKeyDown={(e) => e.stopPropagation()}
	>
		<div
			data-testid="nav-row-actions-fade"
			className={cn(
				"pointer-events-none absolute inset-y-0 right-full w-8 bg-gradient-to-r from-transparent",
				rowFade(isSelected),
			)}
		/>
		{children}
	</div>
)
